import { getUserDisplayName } from '../../../../permissions';
export function onTransformColumns(context, params) {
    return {
        fileId: params.data.fileId,
        version: params.data.version,
        checkInBy: params.data.checkInBy,
        checkInByName: getUserDisplayName(context, params.data.checkInBy),
        contentLength: params.data.contentLength,
        comment: params.data.comment,
    };
}
